<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Customer Create</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item active">Customer Create</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <div class="col-sm-12 formI">
              <div class="card-body">
                <form class="f1" method="post">
                  <div class="f1-steps">
                    <div class="f1-progress">
                      <div
                        class="f1-progress-line"
                        data-now-value="16.66"
                        data-number-of-steps="3"
                      ></div>
                    </div>
                    <div class="f1-step" :class="this.active === 1 && 'active'">
                      <div class="f1-step-icon"><i class="fa fa-user"></i></div>
                      <p>Customer Information</p>
                    </div>
                    <div class="f1-step" :class="this.active === 2 && 'active'">
                      <div class="f1-step-icon"><i class="fa fa-key"></i></div>
                      <p>Billing Information</p>
                    </div>
                    <div class="f1-step" :class="this.active === 3 && 'active'">
                      <div class="f1-step-icon"><i class="fa fa-twitter"></i></div>
                      <p>Owner Information</p>
                    </div>
                    <div class="f1-step" :class="this.active === 4 && 'active'">
                      <div class="f1-step-icon"><i class="fa fa-twitter"></i></div>
                      <p>Other Information</p>
                    </div>
                  </div>
                  <!-- customer information -->
                  <fieldset :class="active === 1 && 'd-block'">
                    <h4 class="mb-3">Customer Information</h4>
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Customer Name *</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="customer_name"
                            placeholder="Enter Name"
                            required=""
                          />
                        </div>
                      </div>
                      <!-- <div class="col-lg-4">
                                    <div class="mb-2">
                                        <label for="f1-first-name">Customer Type</label>
                                        <input class="form-control" id="f1-first-name" type="text" v-model="customer_type" placeholder="Enter Reference" required="">
                                    </div>
                                </div> -->
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Customer Phone</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="customer_phone"
                            placeholder="Enter Phone"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-last-name">Customer Email</label>
                          <input
                            class="f1-last-name form-control"
                            id="f1-last-name"
                            type="email"
                            v-model="customer_email"
                            placeholder="Customer Email"
                            required=""
                          />
                        </div>
                      </div>
                      <!-- <div class="col-lg-4">
                                    <div class="mb-2">
                                        <label for="f1-first-name">Customer/Company Name</label>
                                        <input class="form-control" id="f1-first-name" type="text" v-model="companyName" placeholder="Enter Name" required="">
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="mb-2">
                                        <label for="f1-first-name">Customer/Company Phone</label>
                                        <input class="form-control" id="f1-first-name" type="text" v-model="companyPhone" placeholder="Enter Phone Number" required="">
                                    </div>
                                </div> -->
                      <!-- <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Email</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="customer_email"
                            placeholder="Enter Email"
                            required=""
                          />
                        </div>
                      </div> -->
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Company Name </label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="company_name"
                            placeholder="Enter Company Name "
                            required=""
                          />
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">BIN Number *</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="bin_number"
                            placeholder="BIN Number"
                            required=""
                          />
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Initiation Date *</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="date"
                            v-model="initial_date"
                            placeholder="Enter Initiation Date"
                            required=""
                          />
                        </div>
                      </div>
                    </div>

                    <!-- <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Product Details</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="product_details"
                            placeholder="Enter Product Details"
                            required=""
                          />
                        </div>
                    </div> -->

                    <h4 class="my-3">Customer Address</h4>
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label class="sr-only" for="f1-email">Flat Number</label>
                          <input
                            class="f1-email form-control"
                            id="f1-email"
                            type="text"
                            v-model="customer_flat_no"
                            placeholder="Enter Flat Number"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label class="sr-only" for="f1-email">Houser Number</label>
                          <input
                            class="f1-email form-control"
                            id="f1-email"
                            type="text"
                            v-model="customer_house_no"
                            placeholder="Enter Houser Number"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label class="sr-only" for="f1-email">Road Number</label>
                          <input
                            class="f1-email form-control"
                            id="f1-email"
                            type="text"
                            v-model="customer_road_no"
                            placeholder="Enter Road Number"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label class="sr-only" for="f1-email">Block Number</label>
                          <input
                            class="f1-email form-control"
                            id="f1-email"
                            type="text"
                            v-model="customer_block_no"
                            placeholder="Enter Block Number"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label class="sr-only" for="f1-email">District</label>
                          <select
                            class="f1-email form-control"
                            v-model="district_id"
                            @click="onDistrictAction"
                            v-if="this.districtList.length > 0"
                          >
                            <option value="" selected>Select District *</option>
                            <option
                              :key="district.id"
                              v-for="district in districtList"
                              :value="district.id"
                              @change="
                                () => {
                                  this.district_id = district.id;
                                }
                              "
                            >
                              {{ district.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label class="sr-only" for="f1-email">Area One</label>
                          <select
                            class="f1-email form-control"
                            v-model="area_one"
                            v-if="this.areaList?.length > 0"
                          >
                            <option value="" selected>Select Area One</option>
                            <option
                              :key="district.id"
                              v-for="district in areaList"
                              :value="district.id"
                              @change="
                                () => {
                                  this.area_one = district.id;
                                }
                              "
                            >
                              {{ district.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <!-- <div class="col-lg-4">
                        <div class="mb-2">
                          <label class="sr-only" for="f1-email">Area Two</label>
                          <select
                            class="f1-email form-control"
                            v-model="area_two"
                            v-if="this.districtList.length > 0"
                          >
                          <option value="" selected>Select Area Two</option>
                            <option
                              :key="district.id"
                              v-for="district in districtList"
                              :value="district.id"
                              @change="
                                () => {
                                  this.area_two = district.id;
                                }
                              "
                            >
                              {{ district.name }}
                            </option>
                          </select>
                        </div>
                      </div> -->
                    </div>
                    <div class="f1-buttons">
                      <button
                        class="btn btn-primary btn-next"
                        type="submit"
                        @click.prevent="activeTab(2)"
                      >
                        Next
                      </button>
                    </div>
                  </fieldset>

                  <!-- billing information -->
                  <fieldset :class="active === 2 && 'd-block'">
                    <h4 class="mb-3">Bandwidth Information</h4>
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Bandwidth MB *</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="Number"
                            v-model="bandwidth"
                            placeholder="Enter Bandwidth"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Bandwidth Type *</label>
                          <!-- <div class="card-body animate-chk pt-1">
                            <label for="edo-ani">
                              <input
                                class="radio_animated"
                                id="edo-ani"
                                type="radio"
                                v-model="bandwidth_type"
                                checked=""
                              />
                              Dedicated
                            </label>
                            <label class="pl2" for="edo-ani1">
                              <input
                                class="radio_animated"
                                id="edo-ani1"
                                type="radio"
                                v-model="bandwidth_type"
                              />
                              Shared
                            </label>
                          </div> -->
                          <select
                            class="f1-email form-control"
                            v-model="bandwidth_type"
                            required=""
                          >
                            <option>Select Bandwidth</option>
                            <option value="1">Dedicated</option>
                            <option value="2">Shared</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <h4 class="my-3">Billing Information</h4>
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Biller Name</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="billing_contact_name"
                            placeholder="Enter Biller Name"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Biller Designation</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="billing_contact_designation"
                            placeholder="Enter Designation"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Biller Phone</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="billing_contact_phone_one"
                            placeholder="Enter Phone Number"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Biller Secondary Phone</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="billing_contact_phone_two"
                            placeholder="Enter Secondary Phone Number"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-last-name">Biller Email</label>
                          <input
                            class="f1-last-name form-control"
                            id="f1-last-name"
                            type="email"
                            v-model="billing_contact_email"
                            placeholder="Enter Email"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-last-name">Biller Address</label>
                          <input
                            class="f1-last-name form-control"
                            id="f1-last-name"
                            type="text"
                            v-model="billing_address"
                            placeholder="Enter Address"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Billing Date</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="number"
                            v-model="billing_date"
                            placeholder="Enter Billing Date"
                            required=""
                          />
                        </div>
                      </div>
                      <!-- <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">MRC</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="Number"
                            v-model="mrc"
                            placeholder="0"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">OTC</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="Number"
                            v-model="otc"
                            placeholder="0"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Total(including VAT)</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="Number"
                            v-model="total_price_with_vat"
                            placeholder="0"
                            required=""
                          />
                        </div>
                      </div> -->
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Opening Balance</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="Number"
                            v-model="opening_balance"
                            placeholder="0"
                            required=""
                          />
                        </div>
                      </div>
                      <!-- <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Recurring Period</label>
                          <div class="card-body animate-chk pt-1">
                            <label for="edo-ani">
                              <input
                                class="radio_animated"
                                id="edo-ani"
                                type="radio"
                                v-model="recuring_period"
                                checked=""
                              />
                              Monthly
                            </label>
                            <label class="pl2" for="edo-ani1">
                              <input
                                class="radio_animated"
                                id="edo-ani1"
                                type="radio"
                                v-model="recuring_period"
                              />
                              Yearly
                            </label>
                          </div>
                        </div>
                      </div> -->
                      <!-- <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Active Status</label>
                          <div class="media-body switch-md">
                            <label class="switch">
                              <input type="checkbox" checked="true" /><span
                                class="switch-state"
                              ></span>
                            </label>
                          </div>
                        </div>
                      </div> -->
                    </div>
                    <!-- <h4 class="my-3">Contact Information</h4> -->
                    <!-- <div class="row">
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label class="sr-only">Name</label>
                          <input
                            class="form-control"
                            id="dd"
                            type="text"
                            placeholder="Enter Name"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label class="sr-only">Designation</label>
                          <input
                            class="form-control"
                            id="text"
                            type="number"
                            placeholder="Enter Designation"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label class="sr-only">Phone One</label>
                          <input
                            class="form-control"
                            id="dd"
                            type="number"
                            placeholder="Enter Number"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label class="sr-only">Phone Two</label>
                          <input
                            class="form-control"
                            id="dd"
                            type="number"
                            placeholder="Enter Number"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label class="sr-only">Email</label>
                          <input
                            class="form-control"
                            id="dd"
                            type="email"
                            placeholder="Enter Email"
                            required=""
                          />
                        </div>
                      </div>
                    </div> -->
                    <div class="f1-buttons">
                      <button
                        class="btn btn-primary btn-previous mx-1"
                        type="button"
                        @click.prevent="activeTab(1)"
                      >
                        Previous
                      </button>
                      <button
                        class="btn btn-primary btn-next"
                        type="button"
                        @click.prevent="activeTab(3)"
                      >
                        Next
                      </button>
                    </div>
                  </fieldset>

                  <!-- Owner Information -->
                  <fieldset :class="active === 3 && 'd-block'">
                    <h4 class="mb-3">Owner Information</h4>
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Owner Name</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="owner_name"
                            placeholder="Enter Owner Name"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Owner Designation</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="owner_designation"
                            placeholder="Enter Owner Designation"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Owner Phone</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="owner_phone_one"
                            placeholder="Enter Owner Phone"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Owner Phone (secondary)</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="owner_phone_two"
                            placeholder="Enter Owner Phone"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Owner Email</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="email"
                            v-model="owner_email"
                            placeholder="Enter Owner Email"
                            required=""
                          />
                        </div>
                      </div>
                    </div>

                    <h4 class="my-3">Technical Contact Information</h4>
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Technical Name</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="technical_name"
                            placeholder="Enter Technical Name"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Technical Designation</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="technical_designation"
                            placeholder="Enter Technical Designation"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Technical Phone</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="technical_phone_one"
                            placeholder="Enter Technical Phone"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Technical Phone (secondary)</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="technical_phone_two"
                            placeholder="Enter Technical Phone"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Technical Email</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="email"
                            v-model="technical_email"
                            placeholder="Enter Technical Email"
                            required=""
                          />
                        </div>
                      </div>
                    </div>

                    <div class="f1-buttons">
                      <button
                        class="btn btn-primary btn-previous mx-1"
                        type="button"
                        @click.prevent="activeTab(2)"
                      >
                        Previous
                      </button>
                      <button
                        class="btn btn-primary btn-next"
                        type="button"
                        @click.prevent="activeTab(4)"
                      >
                        Next
                      </button>
                    </div>
                  </fieldset>

                  <!-- Owner Information -->
                  <fieldset :class="active === 4 && 'd-block'">
                    <h4 class="mb-3">Other Information</h4>
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">POP *</label>
                          <select
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="pop_id"
                            placeholder="Enter POP"
                            required=""
                          >
                            <option value="" disabled>Select POP</option>
                            <option v-for="p in popList" :key="p.id" :value="p.id">
                              {{ p.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-email">Connection Type *</label>
                          <select
                            class="f1-email form-control"
                            v-model="connectionType"
                            v-if="this.connectionTypes?.length > 0"
                          >
                            <option value="0" selected>Select Type</option>
                            <option
                              :key="district.id"
                              v-for="district in connectionTypes"
                              :value="district.id"
                              @change="
                                () => {
                                  this.area_one = district.id;
                                }
                              "
                            >
                              {{ district.title }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <!-- <div class="col-lg-4">
                                    <div class="mb-2">
                                        <label for="f1-first-name">Effective Date</label>
                                        <input class="form-control" id="f1-first-name" type="date" name="f1-first-name" placeholder="Enter Date" required="">
                                    </div>
                                </div> -->
                      <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Remarks</label>
                          <input
                            class="form-control"
                            id="f1-first-name"
                            type="text"
                            v-model="remark"
                            placeholder="Enter Remarks"
                            required=""
                          />
                        </div>
                      </div>

                      <!-- <div class="col-lg-4">
                        <div class="mb-2">
                          <label for="f1-first-name">Active Status</label>
                          <div class="media-body switch-md">
                            <label class="switch">
                              <input type="checkbox" checked="true" /><span
                                class="switch-state"
                              ></span>
                            </label>
                          </div>
                        </div>
                      </div> -->
                    </div>

                    <div class="f1-buttons">
                      <button
                        class="btn btn-primary btn-previous mx-1"
                        type="button"
                        @click.prevent="activeTab(3)"
                      >
                        Previous
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary btn-next"
                        @click.prevent="createCustomer"
                      >
                        Create
                      </button>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
      </div>
    </div>
  </div>
</template>

<script>
import CustomerAPI from "../../services/customer.API";
import areaRelatedAPI from "../../services/areaRelatedAPI";
import pop_typeAPI from "../../services/pop_type.API";
import connectionTypeAPI from "../../services/connectionType.API";

export default {
  name: "CustomerCreate",
  data() {
    return {
      active: 1,
      customer_type: 1,
      customer_name: "",
      customer_email: "",
      customer_phone: "",
      companyName: "",
      companyPhone: "",
      // product_details: "",
      bin_number: "",
      company_name: "",
      initial_date: "",
      customer_flat_no: "",
      customer_house_no: "",
      customer_road_no: "",
      customer_block_no: "",
      district_id: "",
      area_one: "",
      area_two: "",
      pop_id: "",
      remark: "",
      bandwidth_type: "",
      bandwidth: "",
      billing_date: "",
      mrc: "",
      otc: "",
      total_price_with_vat: "",
      opening_balance: "",
      recuring_period: "",
      owner_name: "",
      owner_designation: "",
      owner_phone_one: "",
      owner_phone_two: "",
      owner_email: "",
      technical_name: "",
      technical_designation: "",
      technical_phone_one: "",
      technical_phone_two: "",
      technical_email: "",
      billing_contact_name: "",
      billing_contact_designation: "",
      billing_contact_phone_one: "",
      billing_contact_phone_two: "",
      billing_contact_email: "",
      billing_address: "",
      districtList: [],
      popList: [],
      areaList: [],
      connectionTypes: [],
      connectionType: "",
    };
  },
  mounted() {
    // get District
    // this.getDistrictList();
    areaRelatedAPI.districtList().then(
      (response) => {
        this.districtList = response.data.data.map((e) => {
          return {
            ...e,
            code: e.id,
            label: e.name,
          };
        });
      },
      (err) => {
        if (err.response.data.success === false) {
          this.districtList = [];
        }
      }
    );

    // pop list
    pop_typeAPI.getList().then((response) => {
      this.popList = response.data.data;
    });
    // area list
    // areaRelatedAPI.getList().then((response) => {
    //   this.areaList = response.data.data;
    // });
    // list
    connectionTypeAPI.typeList().then((response) => {
      this.connectionTypes = response.data.data;
    });
  },
  methods: {
    onDistrictAction() {
      // if (this.district_id) {
      areaRelatedAPI.districtWiseArea(this.district_id).then(
        (res) => {
          this.areaList = res.data.data;
        },
        (err) => {
          console.log(err);
          this.areaList = [];
        }
      );
      // }
    },
    activeTab(stateID) {
      if (this.active == 1) {
        if (this.customer_name == "") {
          this.$moshaToast("Customer Name is Required", {
            type: "info",
            position: "top-right",
            showIcon: true,
          });
        } else if (this.customer_email == "" && this.customer_phone == "") {
          this.$moshaToast("Customer Email/Phone is Required", {
            type: "info",
            position: "top-right",
            showIcon: true,
          });
        } else if (this.bin_number == "") {
          this.$moshaToast("BIN Number is Required", {
            type: "info",
            position: "top-right",
            showIcon: true,
          });
        } else if (this.initial_date == "") {
          this.$moshaToast("Initialization Date Required", {
            type: "info",
            position: "top-right",
            showIcon: true,
          });
        } else if (this.district_id == "") {
          this.$moshaToast("District is Required", {
            type: "info",
            position: "top-right",
            showIcon: true,
          });
        } else {
          this.active = stateID;
        }
      } else if (this.active == 2) {
        if (this.bandwidth == "") {
          this.$moshaToast("Bandwidth is Required", {
            type: "info",
            position: "top-right",
            showIcon: true,
          });
        } else if (this.bandwidth_type == "") {
          this.$moshaToast("Bandwidth Type is Required", {
            type: "info",
            position: "top-right",
            showIcon: true,
          });
        } else {
          this.active = stateID;
        }
      } else if (this.active == 3) {
        this.active = stateID;
      } else if (this.active == 4) {
        if (this.pop_id == "") {
          this.$moshaToast("POP is Required", {
            type: "info",
            position: "top-right",
            showIcon: true,
          });
        } else if (this.connectionType == "") {
          this.$moshaToast("Connection Type is Required", {
            type: "info",
            position: "top-right",
            showIcon: true,
          });
        } else {
          this.active = stateID;
        }
      }
    },
    createCustomer() {
      let data = {
        customer_type: this.connectionType,
        customer_name: this.customer_name,
        customer_phone: this.customer_phone,
        customer_email: this.customer_email,
        company_name: this.company_name,
        bin_number: this.bin_number,
        initial_date: this.initial_date,
        customer_flat_no: this.customer_flat_no,
        customer_house_no: this.customer_house_no,
        customer_road_no: this.customer_road_no,
        customer_block_no: this.customer_block_no,
        district_id: this.district_id,
        area_one: this.area_one,
        area_two: this.area_two,
        pop_id: this.pop_id,
        remark: this.remark,
        bandwidth_type: this.bandwidth_type,
        bandwidth: this.bandwidth,
        billing_date: 10 || this.billing_date,
        mrc: this.mrc,
        otc: this.otc,
        total_price_with_vat: this.total_price_with_vat,
        opening_balance: this.opening_balance,
        recuring_period: this.recuring_period,
        owner_name: this.owner_name,
        owner_designation: this.owner_designation,
        owner_phone_one: this.owner_phone_one,
        owner_phone_two: this.owner_phone_two,
        owner_email: this.owner_email,
        technical_name: this.technical_name,
        technical_designation: this.technical_designation,
        technical_phone_one: this.technical_phone_one,
        technical_phone_two: this.technical_phone_two,
        technical_email: this.technical_email,
        billing_contact_name: this.billing_contact_name,
        billing_contact_designation: this.billing_contact_designation,
        billing_contact_phone_one: this.billing_contact_phone_one,
        billing_contact_phone_two: this.billing_contact_phone_two,
        billing_contact_email: this.billing_contact_email,
        billing_address: this.billing_address,
      };
      CustomerAPI.createCustomer(data)
        .then((response) => {
          this.$moshaToast(response.data.message, {
            type: "success",
            position: "top-right",
            showIcon: true,
          });
          //

          if (response.data.finalId == 0) {
            this.$router.push("/customer/list");
          } else {
            this.$router.push("/customer/details/" + response.data.finalId);
          }
        })
        .catch((error) => {
          // console.log(error.response.data.success);
          this.$moshaToast(error.response.data.message, {
            type: "danger",
            position: "top-right",
            showIcon: true,
          });
        });
    },
  },
};
</script>
<style scoped>
fieldset.d-block {
  background: white;
  border-radius: 15px;
  border: 1px solid white;
  padding: 25px;
}
</style>
